import {typography} from "material-ui/styles";
import {blue200, white} from "material-ui/styles/colors";

const styles = {
    buttons: {
        float: 'right'
    },
    container: {
        position: 'relative',
        margin: '-23px 0 0 -5px',
        height: 'calc(100vh - 57px)'
    },
    map: {
        height: 300,
        marginBottom: '20px'
    },
    rightIcon: {
        position: 'absolute',
        right: 10
    },
    mapFull: {
        height: '80vh',
        marginBottom: '20px'
    },
    subHeader: {
        fontSize: 15,
        fontWeight: typography.fontWeightLight,
        backgroundColor: blue200,
        color: white,
        marginBottom: '1em'
    },
    titleBar: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        alignContent: 'space-between'
    },
    statusButton: {
        display: 'inline',
        alignSelf: 'flex-start',
        background: 'none',
        boxShadow: 'none',
    },
    title: {
        paddingTop: '12px',
        display: 'inline',
        alignSelf: 'flex-start',
        fontSize: 24,
        fontWeight: typography.fontWeightLight,
        marginBottom: 20,
        marginTop: 0,
        width: 'auto'
    }
    /*
    map: {
        verticalAlign: 'top',
        display: 'inline-block',
        position: 'relative',
        height: 300,
        width: '95%',
        left: 0
    },
    lateralavatardiv: {
        display: 'inline-block',
        width: '5%',
        verticalAlign: 'top',
        position: 'relative'
    },
    lateralavatar: {
        display: 'block',
        margin: 'auto',
        backgroundColor: 'none',
        borderRadius: 0
    },
    lateralbox: {
        padding: 0,
        height: 300,
        verticalAlign: 'top',
        backgroundColor: green400,
        textAlign: 'right'
    }*/
};

export default styles;



// WEBPACK FOOTER //
// src/containers/reports/ReportPage/ReportPage.css.js